















































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { CSSStyleOptions } from '@libs-uuif/shared/common-types';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { CoreStoreState } from '../../core.store';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { helpContentData } from '@/shared/help-content-data/msw-help-data.ts';
const cssPrefix = 'help-container';

@Component({
  components: {
    SwIconButton,
    SwIcon,
    SwScrollView,
  },
})
export default class HelpContainerSlide extends SwExtendedVue {
  cssPrefix =  cssPrefix;

  @Prop({ required: true })
  visible: boolean;

  @Prop()
  helpId: string[];

  helplink:string = '';

  parser = new DOMParser();

  @State((state: RootStoreState) => state.CoreStoreModule.pageViewWidth)
  pageViewWidth: CoreStoreState['pageViewWidth'];

  rootVisible = this.visible;
  rootId = this.helpId;

  @Watch('visible', { immediate: true })
  private onVisibleChange(val: boolean) {
    if (val) {
      this.rootVisible = true;
    }
    this.helplink = '';
    helpContentData.forEach((node) => {
      this.helpId.forEach((eleId) => {
        if (eleId === node.helpId) {
          this.helplink =  this.helplink + node.content;
        }
      });
    });
  }

/*@Watch('helpId', { immediate: true })
  private onHelpIdChange(val: string) {
    // this.rootId = val;
  }*/
  mounted() {
    this.helplink = '';
  }
  get overlayStyle(): CSSStyleOptions {
    /* return {
      width: `${this.pageViewWidth}px`,
    }; */
    return {
      width:'100%',
    };
  }
  private onAfterSlideLeave() {
    this.rootVisible = false;
  }

  private onCloseSlide() {
    this.$emit('request-close');
  }

  beforeDestroy() {
    this.helplink = '';
  }
}
